<script>
export default {
    name: "GoodsReturnNoteList",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    components: {
      "posted-list-tab": () => import('./list/Posted.vue'),
      "unposted-list-tab": () => import('./list/Unposted.vue'),
    },
}
</script>

<template>
<tail-base-layout>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
          <div class="flex flex-wrap w-full">
            <h5 class="font-medium text-sm">Purchase Orders</h5>
            <div class="flex-1 flex justify-end">
                <router-link :to="{ name: 'suppliers-dashboard.purchase-orders.create' }" class="btn-info btn-sm text-xs"><i class="fa fa-plus"></i> Purchase Order</router-link>
            </div>
          </div>
        </template>
        <template v-slot:card-body>
            <div class="w-full">
                <ul class="flex border-b-2">
                  <li class="-mb-px mr-1">
                    <a @click.prevent="active=0" 
                      class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
                      :class="active == 0 ? activeClass : inActiveClass" href="javascript:void()">Posted</a>
                  </li>
                  <li class="-mb-px mr-1">
                    <a @click.prevent="active=1" 
                      class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
                      :class="active == 1 ? activeClass : inActiveClass" href="javascript:void()">Unposted</a>
                  </li>
                </ul>
                <div v-if="active==0">
                    <posted-list-tab/>
                </div>
                <div v-if="active==1">
                    <unposted-list-tab/>
                </div>
            </div>
        </template>
        <template v-slot:card-footer>
           <div class="w-full text-right">
             <router-link :to="{ name: `suppliers-dashboard.index` }" class="btn-sm btn-danger text-xs rounded"><i class="fa fa-caret-left"></i> Back</router-link>
           </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>
